import {
  Button,
  Card,
  Col,
  Divider,
  Input,
  message,
  Radio,
  Row,
  Spin,
  Typography,
} from "antd";
import React, { useEffect, useState } from "react";
import Get from "../services/Get";
import Post from "../services/Post";
import { io } from "socket.io-client";
import { useNavigate } from "react-router-dom";

const SwitchToPaid = () => {
  const [loading, setLoading] = useState(false);
  const [referCode, setReferCode] = useState("COMPANY");
  const [paymentMethod, setPaymentMethod] = useState("online");

  const navigate = useNavigate();

  const getMlmData = async () => {
    try {
      const res = await Get.MLMEditData();
      if (res.error) {
        message.error(res.error);
      } else {
        console.log(res);
        setReferCode(res.data.upline.refer_code);
      }
    } catch {
      console.log("Error fetching data");
    }
  };

  useEffect(() => {
    getMlmData();
  }, []);

  const joiningFee = 600;
  const gst = joiningFee * 0.18;
  const totalAmount = joiningFee + gst;

  const pay_now = async () => {
    try {
      let amount = totalAmount;

      if (!amount) {
        message.error("Amount not found!");
        return null;
      }

      setLoading(true);

      const res = await Post.PaymentLink(amount);
      console.log(res);

      const { paymentLink, order_id } = res.data;

      if (!paymentLink || !order_id) {
        message.error("Failed to retrieve payment link!");
        setLoading(false);
        return null;
      }

      const paymentWindow = window.open(
        paymentLink,
        "_blank",
        "width=1000,height=800"
      );

      if (!paymentWindow) {
        message.error("Popup blocked! Please allow popups and try again.");
        setLoading(false);
        return null;
      }

      let popupClosed = false;

      return new Promise((resolve, reject) => {
        const checkPopupClosed = setInterval(() => {
          if (paymentWindow.closed) {
            clearInterval(checkPopupClosed);
            popupClosed = true;
            message.error("Payment popup closed before completion!");
            setLoading(false);
            reject(null);
          }
        }, 1000);

        const socket = io.connect("https://socket.rebatedekho.com");

        // Join a unique room for this payment
        console.log(order_id);
        socket.emit("join-room", order_id);
        console.log("room joined");

        socket.on("callback-event", (data) => {
          console.log("Payment callback received:", data);
          const parsedData = data;

          if (popupClosed) return;

          if (parsedData.STATUS_CODE === "RP000") {
            message.success(parsedData.ERROR_DESC);
            clearInterval(checkPopupClosed);
            socket.disconnect();
            resolve(parsedData.ORDER_ID);
          } else {
            message.error(parsedData.ERROR_DESC);
          }
        });
      });
    } catch (error) {
      message.error("Something went wrong while processing payment!");
      console.error(error);
      setLoading(false);
      return null;
    }
  };

  const handleSubmit = async () => {
    setLoading(true);

    try {
      const data = {};

      data.amount = totalAmount;
      data.method = paymentMethod;
      data.description = "Successfully Switched to Paid Plan";
      if (paymentMethod == "online") {
        const payId = await pay_now();
        data.pay_id = payId;
      }

      console.log(data);

      const res = await Post.SwitchPlan(data);
      console.log("Response == ", res);

      if (res) {
        if (res.error) {
          console.log(res.error);
          message.error(res.error);
        } else {
          console.log("Success!");
          message.success("Successfully Switched to Paid Plan!");
          navigate('/user/affiliate-program');
        }
      }
    } catch (error) {
      message.error(error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="layout-content">
      <Row gutter={[24, 24]} justify="center">
        <Col xs={24} md={12}>
          <Card bordered={true}>
            <Row style={{ marginBottom: 16 }}>
              <Col span={24}>
                <Typography.Text strong>Enter Refer Code:</Typography.Text>
                <Input
                  type="text"
                  placeholder="Enter refer code"
                  value={referCode}
                  onChange={(e) => setReferCode(e.target.value)}
                  style={{ marginTop: 8 }}
                  disabled={true}
                />
              </Col>
            </Row>
            <Typography.Paragraph>
              ✅ Joining amount <strong>₹600 + GST</strong> <br />✅ Earn{" "}
              <strong>15% commission</strong> on direct referral
            </Typography.Paragraph>
            <Divider />
            <Typography.Title level={5}>Payment Summary</Typography.Title>
            <Typography.Text>Joining Fees: ₹{joiningFee}</Typography.Text>{" "}
            <br />
            <Typography.Text>GST (18%): ₹{gst.toFixed(2)}</Typography.Text>{" "}
            <br />
            <Typography.Text strong>
              Total Amount: ₹{totalAmount.toFixed(2)}
            </Typography.Text>
            <Divider />
            <Radio.Group
              onChange={(e) => setPaymentMethod(e.target.value)}
              value={paymentMethod}
              style={{ display: "block", margin: "20px 0" }}
            >
              <Radio value="online">Online Payment</Radio>
              <Radio value="wallet">Wallet</Radio>
            </Radio.Group>
            <Button
              type="primary"
              block
              className="form-btn"
              onClick={handleSubmit}
              disabled={loading}
            >
              {loading ? (
                <Spin size="small" />
              ) : (
                `Pay ₹${totalAmount.toFixed(2)}`
              )}
            </Button>
          </Card>
        </Col>
      </Row>
    </div>
  );
};

export default SwitchToPaid;
